"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    validateEmail: ()=>validateEmail,
    pluralize: ()=>pluralize,
    IMG_URL: ()=>IMG_URL,
    CONFIG_URL: ()=>CONFIG_URL,
    fakeItemsArray: ()=>fakeItemsArray,
    typographyRegex: ()=>typographyRegex,
    isImageUrl: ()=>isImageUrl
});
_exportStar(require("./config"), exports);
function _exportStar(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) Object.defineProperty(to, k, {
            enumerable: true,
            get: function() {
                return from[k];
            }
        });
    });
    return from;
}
const validateEmail = (email)=>{
    // Simple email validation using regular expression
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
};
const pluralize = (quantity, word)=>{
    return word + (quantity || 0 > 1 ? 's' : '');
};
const IMG_URL = 'https://dmzzpbgwwctnn.cloudfront.net';
const CONFIG_URL = 'https://d1fzvegns2c9no.cloudfront.net';
const fakeItemCount = 10;
const fakeItemsArray = Array.from({
    length: fakeItemCount
}, (_, index)=>index);
const typographyRegex = /(\{i\}|\{\/i\}|\{b\}|\{\/b\}|\{c:\d+\}|\{\/c:\d+\}|\{s:\d+\}|\{\/s:\d+\})/g;
const isImageUrl = (url)=>/(\.png|\.jpg|\.jpeg)$/i.test(url);
